import { Routes } from '@angular/router';
import { questionsResolver } from 'portal/core/api/api.resolvers';
import { dashboardGuard } from 'portal/features/index/dashboard/dashboard.guard';

export const routes: Routes = [
  {
    // Admin-driven preview pages: outside the `index` layout (no header/footer) and before `''`,
    // which would otherwise catch them. Children are added per previewed entity.
    path: 'preview',
    loadComponent: () => import('./features/preview/preview.component').then((m) => m.PreviewComponent),
    children: [
      {
        path: 'service',
        title: 'preview.page',
        data: { previewPage: true },
        loadComponent: () =>
          import('./features/preview/service-preview/service-preview.component').then(
            (m) => m.ServicePreviewComponent,
          ),
      },
      {
        path: 'community',
        title: 'preview.page',
        data: { previewPage: true },
        loadComponent: () =>
          import('./features/preview/community-preview/community-preview.component').then(
            (m) => m.CommunityPreviewComponent,
          ),
      },
      {
        path: 'organization',
        title: 'preview.page',
        data: { previewPage: true },
        loadComponent: () =>
          import('./features/preview/organization-preview/organization-preview.component').then(
            (m) => m.OrganizationPreviewComponent,
          ),
      },
      // Unknown /preview/<x>: renders nothing and never reaches `ready`, so the admin times out
      // into its error text instead of falling through to the `index` layout (which calls /api).
      { path: '**', children: [] },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./features/index/index.component').then((m) => m.IndexComponent),
    children: [
      {
        path: '',
        title: 'main.page',
        data: {
          reuse: true,
        },
        loadComponent: () => import('./features/index/main/main.component').then((m) => m.MainComponent),
      },
      {
        path: 'communities/:slug',
        title: 'community-details.page',
        loadComponent: () => import('./features/index/community-details/community-details.component').then((m) => m.CommunityDetailsComponent),
      },
      {
        path: 'communities',
        title: 'communities.page',
        data: {
          reuse: true,
        },
        loadComponent: () => import('./features/index/communities/communities.component').then((m) => m.CommunitiesComponent),
      },
      {
        path: 'dashboard',
        title: 'dashboard.page',
        canActivate: [dashboardGuard],
        loadComponent: () => import('./features/index/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },

      {
        path: 'registration/confirm',
        title: 'auth.registration.page',
        loadComponent: () => import('./features/auth/registration-confirm/registration-confirm.component').then((m) => m.RegistrationConfirmComponent),
      },
      {
        path: 'registration',
        title: 'auth.registration.page',
        loadComponent: () => import('./features/auth/auth.component').then((m) => m.AuthComponent),
      },
      {
        path: 'login',
        title: 'auth.login.page',
        loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'forgot-password',
        title: 'auth.forgot-password.page',
        loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
      },
      {
        path: 'reset-password',
        title: 'auth.reset-password.page',
        loadComponent: () => import('./features/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'change-password',
        title: 'auth.change-password.page',
        loadComponent: () => import('./features/auth/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
      },
      {
        path: 'delete-account',
        title: 'auth.delete-account.page',
        loadComponent: () => import('./features/auth/delete-account/delete-account.component').then((m) => m.DeleteAccountComponent),
      },
      {
        path: 'profile',
        title: 'profile.page',
        loadComponent: () => import('./features/auth/profile/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'questionnaire/edit',
        title: 'questionnaire.page',
        loadComponent: () => import('./features/index/questionnaire/questionnaire.component').then((m) => m.QuestionnaireComponent),
        data: {
          mode: 'edit',
        },
        resolve: {
          questions: questionsResolver,
        },
      },
      {
        path: 'questionnaire',
        title: 'questionnaire.page',
        loadComponent: () => import('./features/index/questionnaire/questionnaire.component').then((m) => m.QuestionnaireComponent),
        resolve: {
          questions: questionsResolver,
        },
      },
      {
        path: 'services/:id',
        title: 'service-details.page',
        loadComponent: () => import('./features/index/service-details/service-details.component').then((m) => m.ServiceDetailsComponent),
      },
      {
        path: 'services',
        title: 'services.page',
        data: {
          reuse: true,
        },
        loadComponent: () => import('./features/index/services/services.component').then((m) => m.ServicesComponent),
      },
      {
        path: 'support-centers',
        title: 'support-centers.page',
        data: {
          reuse: true,
        },
        loadComponent: () => import('./features/index/support-centers/support-centers.component').then((m) => m.SupportCentersComponent),
      },
      {
        path: ':slug',
        title: 'conditions.page',
        loadComponent: () =>
          import('./features/index/condition/condition.component').then(
            (m) => m.ConditionComponent,
          ),
      },
      {
        path: '**',
        title: 'conditions.not-found',
        data: {
          layout: { footer: false, feedback: false, fullScreen: true },
        },
        loadComponent: () =>
          import('./features/index/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
          ),
      },
    ],
  },
];
